import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { register } from '../../services/api';
import AdminLayout from '../../components/AdminLayout';
import {
  LoginContainer,
  LoginForm,
  Title,
  InputGroup,
  Input,
  Label,
  Button,
  ErrorMessage
} from './LoginStyles';

const Register = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setIsLoading(true);

    try {
      const data = await register(username, password);
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('isAdminAuthenticated', 'true');
      navigate('/admin/dashboard');
    } catch (err) {
      console.log(err);  
      setError('Registration failed. Try again.');
      setTimeout(() => setError(''), 3000);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AdminLayout>
      <LoginContainer>
        <LoginForm onSubmit={handleSubmit}>
          <Title>Register New Admin</Title>
          {error && <ErrorMessage>{error}</ErrorMessage>}

          <InputGroup delay="0.2s">
            <Input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={isLoading}
            />
            <Label>Username</Label>
          </InputGroup>

          <InputGroup delay="0.4s">
            <Input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
            />
            <Label>Password</Label>
          </InputGroup>

          <InputGroup delay="0.6s">
            <Input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              disabled={isLoading}
            />
            <Label>Confirm Password</Label>
          </InputGroup>

          <Button type="submit" disabled={isLoading}>
            {isLoading ? 'Registering...' : 'Register'}
          </Button>
        </LoginForm>
      </LoginContainer>
    </AdminLayout>
  );
};

export default Register;
